import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { BUSINESS, telLink } from "@/data/business";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/explore", label: "Explore Uttarakhand" },
  { to: "/char-dham", label: "Char Dham Yatra" },
  { to: "/weekend-trips", label: "Weekend Trips" },
  { to: "/#fleet", label: "Our Taxi" },
  { to: "/#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-gold/20 bg-black/80 backdrop-blur-xl">
      <div className="container-x flex h-16 items-center justify-between gap-4 sm:h-[72px]">
        <Link to="/" data-testid="nav-logo-link" aria-label="Tingadya Travels home">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-7 lg:flex" data-testid="nav-desktop-menu">
          {LINKS.map((l) => (
            <Link key={l.label} to={l.to} className="text-[13px] font-medium text-mist transition-colors hover:text-gold">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <a href={telLink(BUSINESS.phoneIndiaRaw)} data-testid="nav-call-button" className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-2 text-[13px] font-semibold text-gold transition-colors hover:bg-gold/10">
            <Phone size={14} /> {BUSINESS.phoneIndia}
          </a>
          <Link to="/#enquire" data-testid="nav-plan-trip-button" className="rounded-full bg-gold px-5 py-2 text-[13px] font-bold text-ink transition-all hover:bg-gold-light">
            Plan Your Trip
          </Link>
        </div>
        <button
          className="rounded-lg border border-white/10 p-2 text-white lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-white/10 bg-ink/95 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-menu">
          <div className="container-x flex flex-col gap-1 py-4">
            {LINKS.map((l) => (
              <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="rounded-lg px-3 py-3 text-sm font-medium text-snow transition-colors hover:bg-white/5 hover:text-gold">
                {l.label}
              </Link>
            ))}
            <a href={telLink(BUSINESS.phoneIndiaRaw)} className="mt-2 rounded-lg bg-gold px-3 py-3 text-center text-sm font-bold text-ink" data-testid="nav-mobile-call-button">
              Call {BUSINESS.phoneIndia}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
